<script lang="ts">
  import * as DropdownMenu from "$lib/components/ui/dropdown-menu/index.js";
  import { Button } from "$lib/components/ui/button/index.js";
  import { Avatar } from "bits-ui";
  import { CircleUserRound } from "lucide-svelte";
  import { getContext, onMount } from "svelte";
  import type { AccountInfo } from "@azure/msal-browser";
  import type { AuthContext } from "../../infrastructure/accounts/AuthContext";
  import { msalAuthenticator } from "$src/infrastructure/accounts/auth";
  import { ContextTokens } from "../contexts/ContextTokens";
  import { getUserInitials } from "$src/domain/users/UserSummary";

  let { me, user }: AuthContext = getContext(ContextTokens.Auth);

  function logout() {
    msalAuthenticator.logout();
  }

</script>

{#if $user && $me}
  <DropdownMenu.Root>
    <DropdownMenu.Trigger asChild let:builder>
      <Button
        builders={[builder]}
        variant="user"
        class="border-primary/60 shadow-md h-8 w-8 rounded-full p-2"
      >
        {getUserInitials($me)}
      </Button>
    </DropdownMenu.Trigger>
    <DropdownMenu.Content class="w-56" align="end">
      <DropdownMenu.Label class="font-normal">
        <div class="flex flex-col space-y-1">
          <p class="text-sm font-medium leading-none">{$user?.name}</p>
          <p class="text-xs leading-none text-muted-foreground">
            {$user?.username}
          </p>
        </div>
      </DropdownMenu.Label>
      <DropdownMenu.Separator />
      <DropdownMenu.Group>
        <DropdownMenu.Item>Profile</DropdownMenu.Item>
      </DropdownMenu.Group>
      <DropdownMenu.Separator />
      <DropdownMenu.Item on:click={() => logout()}>Log out</DropdownMenu.Item>
    </DropdownMenu.Content>
  </DropdownMenu.Root>
{/if}
